import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import BusinessDetailsPageActionButtons from '../components/BusinessDetailsPageActionButtons';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import BusinessProfileForm from '../components/BusinessProfileForm';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useGetBusinessProfileHandler } from '../dataHandlers/getBusinessProfileHandler';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import MiciScoreCard from '../../creditIndex/MiciScoreCard';
import { useMiciReport } from '../../creditIndex/hooks/useMiciReport';

const TABS = {
  DETAILS: 'details',
  MICI_SCORE: 'mici_score',
};

export default function BusinessProfileDetailsPage() {
  const { businessProfiles } = useTranslatedMessages();
  const page = businessProfiles?.pages?.details ?? {};
  const tabs = page?.tabs ?? {};
  useDocumentTitle(page?.document_title ?? 'Business Profile Details');
  const { profile_id } = useParams();
  const { businessProfile, isLoading } = useGetBusinessProfileHandler(profile_id);
  const subscription = useSelector((state) => state.subscription.subscription);
  const isMiciFeatureEnabled = Boolean(subscription?.features?.enable_mici);
  const [activeTab, setActiveTab] = useState(TABS.DETAILS);
  const miciActive = isMiciFeatureEnabled && activeTab === TABS.MICI_SCORE;
  const { report: miciReport } = useMiciReport({
    active: miciActive,
    businessProfile,
  });

  if (isLoading || !businessProfile) return <DocumentSkeletonForm />;

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {businessProfile && (
        <Box sx={{ pb: 4 }}>
          <TopBar
            title={page?.top_bar_title ?? 'Business Profile Details'}
            identifier={businessProfile?.profile_id}
            subTitle={businessProfile?.profile_id}
          >
            <BusinessDetailsPageActionButtons />
          </TopBar>
        </Box>
      )}

      {isMiciFeatureEnabled && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            textColor="primary"
            indicatorColor="primary"
            aria-label="business profile details tabs"
          >
            <Tab value={TABS.DETAILS} label={tabs?.details ?? 'Details'} />
            <Tab value={TABS.MICI_SCORE} label={tabs?.mici_score ?? 'Marmin Invoice Credit Index (MICI)'} />
          </Tabs>
        </Box>
      )}

      {(!isMiciFeatureEnabled || activeTab === TABS.DETAILS) && (
        <BusinessProfileForm
          onSubmit={() => {}}
          apiErrors={{}}
          initialData={businessProfile}
          readOnly={true}
          edit={false}
          onCancel={() => {}}
        />
      )}

      {miciActive && (miciReport ? <MiciScoreCard data={miciReport} /> : <DocumentSkeletonForm />)}
    </Stack>
  );
}
